import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function EditSymbolMultiple({ open, onClose, user, reload }) {
  const [newValue, setNewValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = useCallback(async () => {
    if (!newValue.trim()) {
      toast.error("Multiple cannot be empty");
      return;
    }

    // ❗ Validate numeric value - allow decimals
    const num = parseFloat(newValue);
    if (isNaN(num)) {
      toast.error("Please enter a valid number");
      return;
    }

    // ❗ Cannot exceed 99
    if (num > 99) {
      toast.error("Multiple cannot be more than 99");
      return;
    }

    // Optional: prevent negative or 0
    if (num <= 0) {
      toast.error("Multiple must be greater than 0");
      return;
    }

    setIsLoading(true);

    const payload = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: user.id,
      token: localStorage.getItem("token"),
      username: localStorage.getItem("username"),
      multiple:
        newValue === null || newValue === undefined || newValue === ""
          ? user.symbol_multiple
          : num, // Use the parsed number here
    };

    console.log(payload,"payloadpayload")

    try {
      const response = await backend.edit_user_multiple(payload);
      if (response.error === "False") {
        toast.success(response.message);
        reload?.();
        onClose?.();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Network Error, Failed to update. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, [newValue]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    
    // Allow decimal numbers with up to 2 decimal places
    if (value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
      setNewValue(value);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99999]">
      <div className="bg-[var(--background)] border-2 border-[var(--hover)] rounded-xl shadow-lg w-[90%] max-w-md p-6">
        <h2 className="text-lg font-bold text-[var(--text)]">
          ✏️ Edit Symbol Multiple
        </h2>

        <input
          type="text" // Changed to text to better handle decimal input
          inputMode="decimal" // Better mobile keyboard
          value={newValue}
          onChange={handleInputChange}
          className="mt-4 w-full border-1 bg-[var(--background)] border-[var(--hover)] text-[var(--text)] rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-[var(--primary)]"
          placeholder="Enter Symbol Multiple (e.g., 0.5, 1.5, 2.0)"
          min="0.1"
          max="99"
          step="0.1" // Allow decimal steps
        />

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-[var(--sell)] text-sm font-semibold text-white transition"
          >
            Cancel
          </button>

          <button
            onClick={handleSave}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-[var(--primary)] text-white transition"
          >
            {isLoading ? "Loading.." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}